"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/chat/v1/portal_common.proto (package spwn.chat.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalChatAnnouncement = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from message spwn.chat.v1.PortalChatAnnouncement
 */
class PortalChatAnnouncement extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string video_id = 1;
         */
        this.videoId = "";
        /**
         * @generated from field: string message = 2;
         */
        this.message = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalChatAnnouncement().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalChatAnnouncement().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalChatAnnouncement().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalChatAnnouncement, a, b);
    }
}
exports.PortalChatAnnouncement = PortalChatAnnouncement;
PortalChatAnnouncement.runtime = protobuf_1.proto3;
PortalChatAnnouncement.typeName = "spwn.chat.v1.PortalChatAnnouncement";
PortalChatAnnouncement.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "video_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
//# sourceMappingURL=portal_common_pb.js.map